/*!
 * Tutku Home — "1 Alana 1 Bedava" · sipariş başına TEK SET kilidi
 * ---------------------------------------------------------------------------
 * Ürün   : Koltuk Kenarı Katlanabilir Bambu Yan Sehpa (1 ALANA 1 BEDAVA)
 * Varyant: gid://shopify/ProductVariant/48191623299330
 *
 * Kural  : Bu üründen sepete DAİMA 2 parça girer ve sipariş başına 1 set ile
 *          sınırlıdır (toplam 2 parça). 2. parçayı Shopify'ın "Satın Al 1, Al 1"
 *          otomatik indirimi ücretsiz yapar — bu script fiyata dokunmaz.
 *
 * Nasıl   : 1) /cart/add isteğinde adet daima 2'ye sabitlenir
 *           2) Ürün sayfasındaki adet kutusu 2'de kilitli (± kapalı)
 *           3) Sepet satırlarında adet kutusu gizlenir (kaldırma ✕ ile)
 *           4) Ürün sepetteyken "Sepete Ekle" kilitlenir → 4 parçaya çıkamaz
 *
 * NOT     : Shopify, BOGO indiriminde sepet satırını ikiye böler
 *           (1 adet ücretli + 1 adet 0,00). Bu Shopify'ın davranışıdır,
 *           adetler gerçekten 1+1'dir — ekranda düzeltilmeye çalışılmaz.
 *
 * Kapsam  : Yalnızca aşağıdaki VARIANT_ID. Mağazanın geri kalanı etkilenmez.
 * Kaldırma: layout/theme.liquid içindeki tutku-bogo.js <script> satırını sil.
 * Kurulum : 2026-07-27 · 720 Dijital
 */
(function () {
  'use strict';

  var VARIANT_ID = '48191623299330';
  var SET_SIZE = 2; // 1 set = 2 parça
  var SOLD_OUT_TEXT = 'Sepetinizde (1 set)';

  /* ---------------------------------------------------------------------
   * 1) AĞ KATMANI — /cart/add isteğinde adedi 1 sete sabitle.
   *    Koleksiyon kartındaki "hızlı ekle" adet=1 gönderir → 2 olur.
   * ------------------------------------------------------------------- */
  var nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    var isCartCall = false;
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      isCartCall = url.indexOf('/cart/') !== -1;
      if (url.indexOf('/cart/add') !== -1 && init && init.body) {
        init.body = patchAddBody(init.body);
      }
    } catch (e) {
      /* sessiz geç — sepet akışını asla bozma */
    }
    var result = nativeFetch.apply(this, arguments);
    if (isCartCall && result && result.then) {
      /* Sepet her değiştiğinde buton kilidini yeniden değerlendir */
      result.then(function () { setTimeout(syncCartLock, 150); }, function () {});
    }
    return result;
  };

  function patchAddBody(body) {
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (String(body.get('id')) === VARIANT_ID) body.set('quantity', SET_SIZE);
      return body;
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (body.get('id') === VARIANT_ID) body.set('quantity', SET_SIZE);
      return body;
    }
    if (typeof body === 'string') {
      try {
        var data = JSON.parse(body);
        if (data && String(data.id) === VARIANT_ID) {
          data.quantity = SET_SIZE;
          return JSON.stringify(data);
        }
        if (data && Array.isArray(data.items)) {
          var touched = false;
          data.items.forEach(function (item) {
            if (String(item.id) === VARIANT_ID) {
              item.quantity = SET_SIZE;
              touched = true;
            }
          });
          if (touched) return JSON.stringify(data);
        }
        return body;
      } catch (e) {
        try {
          var params = new URLSearchParams(body);
          if (params.get('id') === VARIANT_ID) {
            params.set('quantity', SET_SIZE);
            return params.toString();
          }
        } catch (e2) {}
      }
    }
    return body;
  }

  /* ---------------------------------------------------------------------
   * 2) ÜRÜN SAYFASI — adet kutusu 2'de kilitli
   * ------------------------------------------------------------------- */
  function lockProductQuantity() {
    var inputs = document.querySelectorAll('input[data-quantity-variant-id="' + VARIANT_ID + '"]');

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var wrapper = input.closest ? input.closest('quantity-input, quantity-selector') : null;
      var inCart = input.closest && input.closest('cart-items, cart-drawer, .cart-item');
      var isCartLine = inCart || (wrapper && wrapper.classList.contains('cart-quantity'));

      if (isCartLine) {
        /* Sepet satırı: adet kutusunu tamamen gizle (kaldırma ✕ ile yapılır) */
        if (wrapper && wrapper.style.display !== 'none') wrapper.style.display = 'none';
        continue;
      }

      /* Ürün sayfası / hızlı görünüm / sticky bar */
      if (input.dataset.bogoLocked === '1') continue;
      input.value = SET_SIZE;
      input.min = SET_SIZE;
      input.max = SET_SIZE;
      input.readOnly = true;
      input.setAttribute('data-min', SET_SIZE);
      if (wrapper) {
        var btns = wrapper.querySelectorAll('button[name="plus"], button[name="minus"]');
        for (var b = 0; b < btns.length; b++) {
          btns[b].disabled = true;
          btns[b].style.opacity = '0.35';
          btns[b].style.pointerEvents = 'none';
        }
      }
      input.dataset.bogoLocked = '1';
    }
  }

  /* ---------------------------------------------------------------------
   * 3) SEPETTE VARSA "Sepete Ekle" kilidi — sipariş başına tek set
   * ------------------------------------------------------------------- */
  function productForms() {
    var found = [];
    var ids = document.querySelectorAll('input[name="id"]');
    for (var i = 0; i < ids.length; i++) {
      if (String(ids[i].value) !== VARIANT_ID) continue;
      var form = ids[i].form || (ids[i].closest && ids[i].closest('form'));
      if (form && found.indexOf(form) === -1) found.push(form);
    }
    return found;
  }

  function setAddButtonState(locked) {
    var forms = productForms();
    for (var i = 0; i < forms.length; i++) {
      var btns = forms[i].querySelectorAll('[type="submit"], button[name="add"]');
      for (var b = 0; b < btns.length; b++) {
        var btn = btns[b];
        var label = btn.querySelector('span:not(.visually-hidden)') || btn;
        if (locked) {
          if (!btn.dataset.bogoOriginal) btn.dataset.bogoOriginal = label.textContent;
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          label.textContent = SOLD_OUT_TEXT;
        } else if (btn.dataset.bogoOriginal) {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          label.textContent = btn.dataset.bogoOriginal;
          delete btn.dataset.bogoOriginal;
        }
      }
    }
  }

  var checking = false;
  var lastCheck = 0;
  function syncCartLock() {
    var now = new Date().getTime();
    if (checking || now - lastCheck < 600 || !productForms().length) return;
    lastCheck = now;
    checking = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = 0;
        (cart.items || []).forEach(function (item) {
          if (String(item.variant_id) === VARIANT_ID) total += item.quantity;
        });
        setAddButtonState(total >= SET_SIZE);
      })
      .catch(function () {})
      .then(function () { checking = false; });
  }

  /* ---------------------------------------------------------------------
   * Çalıştır + AJAX ile yeniden basılan bölümlerde tekrar uygula
   * ------------------------------------------------------------------- */
  function run() {
    lockProductQuantity();
    syncCartLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Tıklandığı anda kilitle (ağ cevabını bekleme) — çift ekleme penceresini kapatır */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var id = form.querySelector('input[name="id"]');
      if (id && String(id.value) === VARIANT_ID) {
        setTimeout(function () { setAddButtonState(true); }, 0);
        setTimeout(syncCartLock, 900);
      }
    },
    true
  );

  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      lockProductQuantity();
      syncCartLock(); /* içeride 600ms kısıt var — bölüm yeniden basılınca kilidi geri koyar */
    }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  ['cart:refresh', 'cart:update', 'cart:open', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, run);
    document.documentElement.addEventListener(evt, run);
  });
})();
